module.exports = __webpack_public_path__ + "static/media/connections.6b0c018f.svg";